import { getToken } from '@/scripts/token.js';
import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getGamesAxios(isGetAll = true, providerID = null) {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    return {
        method: METHOD.GET,
        url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.GAME_GET}`,
        params: {
            get_all: isGetAll,
            provider_id: providerID,
        },
        headers: {
            Authorization: token,
            'Cache-Control': 'no-cache',
        },
    };
}

export async function getGames(isGetAll = true, providerID = null) {
    const response = await axiosRequest({
        url: constants.URL.GAME_GET,
        method: METHOD.GET,
        requestName: 'GET GAME',
        isLoader: false,
        params: {
            get_all: isGetAll,
            provider_id: providerID,
        },
    });

    return response == null ? [] : response.game_name;
}

export async function createGame(data) {
    const response = await axiosRequest({
        url: constants.URL.GAME_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE GAME',
        data: data,
    });

    return response;
}

export async function updateGame(data) {
    const response = await axiosRequest({
        url: constants.URL.GAME_UPDATE,
        method: METHOD.PUT,
        requestName: 'UPDATE GAME',
        data: data,
    });

    return response == null ? false : true;
}

export async function deleteGame(id) {
    const response = await axiosRequest({
        url: constants.URL.GAME_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE GAME',
        params: {
            game_id: id,
        },
    });

    return response == null ? false : true;
}
